<template>
  <div>
    <Card>
      <p slot="title"> Pending Dana Download </p>

      <Row type="flex" justify="space-between">
        <Col span="7">
          <Select
            v-model="bankAccountId"
            placeholder="Pilih Rekening Bank"
            clearable filterable
            @on-change="updateFilter">
              <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">
                {{ bankAccount.accountName }}
              </Option>
          </Select>
        </Col>
        <Col span="5">
          <ButtonGroup class="custom-group-parent">
            <Button class="custom-group">Tgl. Mutasi</Button>
              <Date-picker
                v-model="mutationDateFilter"
                style="width: 180px;"
                type="daterange"
                format="yyyy-MM-dd"
                @on-change="updateFilter">
              </Date-picker>
          </ButtonGroup>
        </Col>
        <Col span="1">
          <Button type="primary"
            :loading="isLoadingSearch"
            icon="ios-search-strong"
            :disabled="!isSearch"
            @click="getMutation">
              <span v-if="!isLoadingSearch">Cari</span>
              <span v-else>Wait...</span>
          </Button>
        </Col>
        <Col span="9">
          <Button type="primary"
            :loading="isLoadingDownload"
            icon="ios-download-outline"
            :disabled="mutationData.length === 0"
            @click="downloadMutaion">
              <span v-if="!isLoadingDownload">Download</span>
              <span v-else>Wait...</span>
          </Button>
        </Col>
      </Row>

      <br/>

      <!-- list table -->
      <Card>
        <Table border :columns="columnsDataMutation" :data="mutationData"> </Table>
      </Card>

      <!-- table-sheet hidden -->
      <div id="table-to-excel" ref="sheetsDataTableList" hidden></div>

    </Card>
  </div>
</template>

<script>
  import { HTTP } from '@/components/http-lib'
  import moment from 'moment'
  import * as XLSX from 'xlsx'

  const numeral = require('numeral');

  export default {
    data: () => ({
      bankAccounts: [],
      bankAccountId: null,
      mutationDateFilter: [],
      isSearch: false,
      isLoadingSearch : false,
      isLoadingDownload : false,
      columnsDataMutation: [
        {
          title: 'Tanggal Mutasi',
          key: 'mutationDate'
        },
        {
          title: 'Keterangan',
          key: 'notes',
        },
        {
          title: 'Mutasi',
          key: 'mutation'
        },
        {
          title: 'Bank Account Name',
          key: 'accountName'
        },
        {
          title: 'Kode Nota',
          key: 'noteCode'
        },
        {
          title: 'Marking',
          key: 'marking'
        },
        {
          title: 'Marking Group',
          key: 'markingGroup'
        },
        {
          title: 'Status Pembayaran',
          key: 'isPayment'
        }
      ],
      mutationData : [],
    }),
    methods: {
      showDateFormatted: function (stringToFormat) {
        let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
        return moment(dateToFormat).format("DD MMM YYYY");
      },
      updateFilter: function() {
        this.mutationData = [];
        let fBankAccount = this.bankAccountId;
        let fMutationDateFilter = this.mutationDateFilter;

        if((fMutationDateFilter[0] != '' && fMutationDateFilter[0] != null) || (fBankAccount != '' && fBankAccount != undefined)) {
          this.isSearch = true;
        }else {
          this.isSearch = false;
        }
      },
      getBankAccounts: function () {
        HTTP.get("bankAccount/findAll/active")
        .then(response => {
          this.bankAccounts = response.data;
        })
        .catch(e => {
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        });
      },
      getMutation: function(){
        let startDate = null;
        let endDate = null;

        if(this.mutationDateFilter[0] != "" && this.mutationDateFilter[0] != null) {
            startDate = moment(this.mutationDateFilter[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
            endDate = moment(this.mutationDateFilter[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
        }

        this.mutationData = [];
        this.isLoadingSearch = true;

        let payload = {
          bankAccountId : this.bankAccountId,
          startDate: startDate,
          endDate: endDate,
          isDeleted: false
        }

        HTTP
        .post('paymentPending/findByFilter', payload)
        .then(response => {
            console.log({response});
            let parent = this;

            _.forEach(response.data, function(value) {
              let markingheadercode = "";
              let markinggroup = "";

              if (value.marking_header) {
                markingheadercode = value.marking_header.markingheadercode;
              }

              if (value.marking_group) {
                markinggroup = value.marking_group.code;
              }

              let mutation = value.amount != null ? "Rp. " + numeral(value.amount).format('0,0') : '';
              let pending = {
                  mutationDate : value.transactionDate != null ? parent.showDateFormatted(value.transactionDate) : '',
                  notes : value.notes,
                  mutation : mutation,
                  marking : markingheadercode,
                  markingGroup : markinggroup,
                  noteCode : value.noteCode,
                  isPayment : value.isPayment ? 'Sudah' : 'Belum',
                  accountName : value.bank_account.accountName,
                  deptName : value.bank_account.deptName,
              }

              parent.mutationData.push(pending);
            });

            this.isLoadingSearch = false;
        })
        .catch(e => {
            this.isLoadingSearch = false;
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })
      },
      downloadMutaion : function () {
        this.isLoadingDownload = true;
        let data = this.mutationData;
        let columns = this.columnsDataMutation;

        const groupedData = data.reduce((acc, item) => {
          const { deptName } = item;
          // create index deptName array
          if (!acc[deptName] && deptName != null) {
            acc[deptName] = [];
          }

          // push data matched deptName
          if (deptName != null) {
            acc[deptName].push(item);
          }

          return acc;
        }, {});

        console.log({data});
        console.log({groupedData});

        let wb = XLSX.utils.book_new();
        let columnsTemp = _.map(columns, obj => { return obj.title })

        _.forEach(groupedData, dataMap => {
          let sumMutation = 0;
          let dataTemp = _.map(dataMap, obj => {
            let mutationParse = parseFloat(obj.mutation.replace(/Rp\.|\./g, '').replace(/,/g, '') || 0);
            sumMutation += mutationParse;

            return [
              obj.mutationDate,
              obj.notes,
              mutationParse,
              obj.accountName,
              obj.noteCode,
              obj.marking,
              obj.markingGroup,
              obj.isPayment
            ];
          })

          // set header column
          let wsTempData = [ columnsTemp ];

           // set data column
           _.forEach(dataTemp, obj => {
            wsTempData.push(obj);
          })

          // set total mutasi
          let sumMutationArray = ['', 'TOTAL MUTASI', sumMutation];
          wsTempData.push(sumMutationArray);

          let wsTemp = XLSX.utils.aoa_to_sheet(wsTempData);

          // set format ribuan pada sheet
          Object.keys(wsTemp).forEach((key) => {
            if (key.startsWith("C") && !isNaN(wsTemp[key].v)) {
              wsTemp[key].t = "n"; // set tipe sel ke number
              wsTemp[key].z = "#,##0"; // format ribuan dengan titik
            }
          });


          // Membuat workbook dengan beberapa tab
          XLSX.utils.book_append_sheet(wb, wsTemp, dataMap[0].deptName);
        });

        // Menyimpan file Excel
        XLSX.writeFile(wb, `DATA_MUTASI_${moment().format("DDMMYYhhmmss")}.xls`);

        this.isLoadingDownload = false;
      },
    },
    mounted() {
      this.getBankAccounts()
    },
  }
</script>



// WEBPACK FOOTER //
// PaymentPendingDownload.vue?1789e2bf